export default "__VITE_ASSET__5nCx9F4a__"